import { render, staticRenderFns } from "./OrderReturnPageWrapper.vue?vue&type=template&id=2c3a3f7d"
import script from "./OrderReturnPageWrapper.vue?vue&type=script&lang=js"
export * from "./OrderReturnPageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports